<template>
  <el-col :span="8">
    <el-card shadow="hover">
      鼠标悬浮时显示
    </el-card>
  </el-col>
</template>

<script>
export default {
  name: "Card"
}
</script>

<style scoped>

</style>
